import { EnvironmentProviders, makeEnvironmentProviders } from '@angular/core';
import defaultsDeep from '@df/util/fn/defaults-deep';
import { DeepPartial } from '@df/util/type/deep-partial';
import { NCatalogUi } from './df-catalog-ui.config';

export function provideDfCatalogUi(config?: DeepPartial<NCatalogUi.IModuleOptions>): EnvironmentProviders {
    return makeEnvironmentProviders([
        {
            provide: NCatalogUi.OPTIONS,
            useFactory: () => defaultsDeep(config, NCatalogUi.DEFAULT_OPTIONS)
        }
    ]);
}
